// @ts-nocheck

export const localeCodes =  [
  "ar",
  "cs",
  "da",
  "de",
  "en",
  "es",
  "fr",
  "hu",
  "it",
  "ja",
  "ko",
  "nl",
  "pl",
  "sk",
  "sv",
  "tr"
]
export const localeLoaders = {
  ar: [],
  cs: [],
  da: [],
  de: [],
  en: [],
  es: [],
  fr: [],
  hu: [],
  it: [],
  ja: [],
  ko: [],
  nl: [],
  pl: [],
  sk: [],
  sv: [],
  tr: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]
export const normalizedLocales = [
  {
    code: "ar",
    language: "ar",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "cs",
    language: "cs",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "da",
    language: "da",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    language: "de",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "en",
    language: "en",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    language: "es",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    language: "fr",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "hu",
    language: "hu",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    language: "it",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ja",
    language: "ja",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ko",
    language: "ko",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl",
    language: "nl",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pl",
    language: "pl",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "sk",
    language: "sk",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "sv",
    language: "sv",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "tr",
    language: "tr",
    domains: [],
    defaultForDomains: []
  }
]

